/**
 * @generated SignedSource<<d36421192180d527d2fe6d00b0552008>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DevAiFlowSessionsStatus = "COMPLETED" | "FAILED" | "IN_PROGRESS" | "PAUSED" | "PENDING" | "%future added value";
export type flowsQuery$variables = {
  cloudId: string;
  creator: string;
};
export type flowsQuery$data = {
  readonly devai_flowSessionsByCreatorAndCloudId: ReadonlyArray<{
    readonly additionalInfoJSON: string | null;
    readonly id: string;
    readonly sessionARI: string;
    readonly status: DevAiFlowSessionsStatus | null;
  } | null> | null;
};
export type flowsQuery = {
  response: flowsQuery$data;
  variables: flowsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "creator"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "creator",
        "variableName": "creator"
      }
    ],
    "concreteType": "DevAiFlowSession",
    "kind": "LinkedField",
    "name": "devai_flowSessionsByCreatorAndCloudId",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sessionARI",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalInfoJSON",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "flowsQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "flowsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7a5e65fb89307461c737ecf012f199cd",
    "id": null,
    "metadata": {},
    "name": "flowsQuery",
    "operationKind": "query",
    "text": "query flowsQuery(\n  $creator: String!\n  $cloudId: ID!\n) {\n  devai_flowSessionsByCreatorAndCloudId(creator: $creator, cloudId: $cloudId) @optIn(to: \"DevAiFlowSessionsByCreatorAndCloudId\") {\n    id\n    sessionARI\n    status\n    additionalInfoJSON\n  }\n}\n"
  }
};
})();

(node as any).hash = "5a338790b3796f41b3009f0dcc3c934f";

export default node;
